import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Section } from '@/components/Section';
import { Button } from '@/components/ui/button';

export function HomeCTASection() {
  return (
    <Section className="relative overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary to-transparent" />
      </div>

      <div className="relative text-center max-w-3xl mx-auto">
        <motion.h2
          className="text-3xl md:text-5xl font-bold text-white mb-4"
          initial={{ opacity: 0.5, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Let's Start a Conversation
        </motion.h2>

        <motion.p
          className="text-lg text-muted-foreground mb-8"
          initial={{ opacity: 0.5, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
        >
          Whether you are exploring AI adoption, seeking technology insight, or interested in collaboration, I welcome thoughtful conversations.
        </motion.p>

        <motion.div
          className="flex flex-wrap justify-center gap-4"
          initial={{ opacity: 0.5, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2 }}
        >
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 px-8" data-testid="schedule-meeting-btn">
            <Link to="/schedule">Schedule a Conversation</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary/10 px-8" data-testid="send-message-btn">
            <Link to="/contact">Send a Message</Link>
          </Button>
        </motion.div>
      </div>
    </Section>
  );
}
